// About.jsx
import React from "react";
import "../Styles/About.scss";
import drywallImg from "../Image/about-bg.jpg";
import excavatorImg from "../Image/excavator.jpg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const About = () => {
  const { t } = useTranslation();

  return (
    <section className="about">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-text">
          <h1>{t("about_title")}</h1>
          <p>{t("about_description")}</p>

          <div className="about-buttons">
            <Link to="/projects" className="btn primary">
              {t("about_projects")}
            </Link>
            <Link to="/contact" className="btn secondary">
              {t("about_contact")}
            </Link>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="about-services">
        <div className="services-card">
          <img src={drywallImg} alt={t("drywall_img_alt")} />
          <h2>{t("drywall_title")}</h2>
          <p>{t("drywall_desc")}</p>
        </div>

        <div className="services-card">
          <img src={excavatorImg} alt={t("excavator_img_alt")} />
          <h2>{t("excavator_title")}</h2>
          <p>{t("excavator_desc")}</p>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="why-us">
        <h2>{t("why_us_title")}</h2>
        <p className="why-subtitle">{t("why_us_subtitle")}</p>

        <div className="why-grid">
          <div className="why-card">
            <span>✔</span>
            <h3>{t("why_team_title")}</h3>
            <p>{t("why_team_desc")}</p>
          </div>

          <div className="why-card">
            <span>✔</span>
            <h3>{t("why_equipment_title")}</h3>
            <p>{t("why_equipment_desc")}</p>
          </div>

          <div className="why-card">
            <span>✔</span>
            <h3>{t("why_quality_title")}</h3>
            <p>{t("why_quality_desc")}</p>
          </div>

          <div className="why-card">
            <span>✔</span>
            <h3>{t("why_delivery_title")}</h3>
            <p>{t("why_delivery_desc")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;


// import React from "react";
// import "../Styles/About.scss";
// import drywallImg from "../Image/about-bg.jpg";
// import excavatorImg from "../Image/excavator.jpg";

// const About = () => {
//   return (
//     <section className="about">
//       {/* Hero Section */}
//       <div className="about-hero">
//         <div className="about-text">
//           <h1>About Emibau</h1>
//           <p>
//             Emibau is a trusted construction company specializing in
//             high-quality drywall solutions and professional excavator rentals.
//             We combine precision, experience, and modern equipment to deliver
//             reliable results for residential and commercial projects.
//           </p>

//           <div className="about-buttons">
//             <a href="/projects" className="btn primary">
//               Our Projects
//             </a>
//             <a href="/contact" className="btn secondary">
//               Contact Us
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* Services Section */}
//       <div className="about-services">
//         <div className="services-card">
//           <img src={drywallImg} alt="Drywall construction" />
//           <h2>Drywall Construction</h2>
//           <p>
//             From partitions to ceilings, our drywall services ensure clean
//             finishes, durability, and fast installation tailored to your space.
//             Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus
//             amet ex laborum, fuga voluptates accusantium et aut cum dignissimos
//             explicabo reiciendis? Hic quibusdam vel nam cum ea aliquid totam
//             sit.
//           </p>
//         </div>

//         <div className="services-card">
//           <img src={excavatorImg} alt="Excavator rental" />
//           <h2>Excavator Rentals</h2>
//           <p>
//             We provide reliable excavator rentals with modern machinery, ideal
//             for construction, excavation, and landscaping projects. Lorem ipsum
//             dolor, sit amet consectetur adipisicing elit. Libero nam natus,
//             officia quae ut harum? Ex, amet. Quis saepe fugit aliquam nisi,
//             quasi fugiat reprehenderit adipisci fuga autem? Autem, expedita?
//           </p>
//         </div>
//       </div>
//       {/* Why Choose Us */}
//       <div className="why-us">
//         <h2>Why Choose Emibau</h2>
//         <p className="why-subtitle">
//           We deliver quality workmanship, reliable equipment, and professional
//           service on every project, big or small.
//         </p>

//         <div className="why-grid">
//           <div className="why-card">
//             <span>✔</span>
//             <h3>Experienced Team</h3>
//             <p>
//               Our skilled professionals bring years of experience in drywall
//               construction and heavy equipment operations.
//             </p>
//           </div>

//           <div className="why-card">
//             <span>✔</span>
//             <h3>Modern Equipment</h3>
//             <p>
//               We use well-maintained, modern excavators to ensure efficiency,
//               safety, and reliability on-site.
//             </p>
//           </div>

//           <div className="why-card">
//             <span>✔</span>
//             <h3>Quality & Precision</h3>
//             <p>
//               Every detail matters. We focus on precision, durability, and clean
//               finishes that last.
//             </p>
//           </div>

//           <div className="why-card">
//             <span>✔</span>
//             <h3>On-Time Delivery</h3>
//             <p>
//               We respect deadlines and deliver projects on time without
//               compromising quality.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default About;
